import { Drawer, Checkbox, Dropdown } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import styles from "css/mobile/mypage.module.css";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import EndpointDetail from "../meeting/room/Detail";
import { useSelector } from "react-redux";

export default function ResEndpointSideBox({
  isOpenEndpointSideBox,
  closeEndpointSideBox,
  searchEndpointList,
  setSearchEndpointList,
  schedule,
  setSchedule,
  dateTimes,
}) {
  const { t } = useTranslation();
  const [endpointDeptList, setEndpointDeptList] = useState([]);
  const [currentDeptPath, setCurrentDeptPath] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedDept, setSelectedDept] = useState(null);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [room, setRoom] = useState({});

  useEffect(() => {
    if (isOpenEndpointSideBox) {
      setEndpointDeptOption();
    }
  }, [isOpenEndpointSideBox]);

  const setEndpointDeptOption = () => {
    axios
      .get("/schedule/deptList")
      .then((res) => {
        if (res.status === 200) {
          setEndpointDeptList(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getEndpoints = (deptCode) => {
    const param = {
      params: {
        DEPT_CD: deptCode,
        START_TIME: dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00",
        END_TIME: dateTimes.END_DATE + " " + dateTimes.END_TIME + ":00",
      },
    };

    axios
      .get("schedule/getAvailableEndpointList", param)
      .then((res) => {
        if (res.status === 200) {
          const updatedEndpoints = res.data.ENDPOINT.map((endpoint) => ({
            ...endpoint,
            id: endpoint.ENDPOINT_ID,
            title: endpoint.ENDPOINT_NM,
            extendedProps: endpoint,
            isChecked: schedule.ENDPOINT_LIST.some(
              (e) => e.ENDPOINT_ID === endpoint.ENDPOINT_ID
            ),
          }));
          setSearchEndpointList(updatedEndpoints);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const systemtype = useSelector((state) => state.system.isOnline);
  const handleSearchEndpointCheck = (endpoint) => {
    if (
      (schedule.SCHEDULE_TYPE === "CD0205" ||
        schedule.SCHEDULE_TYPE === "CD0206") &&
      schedule.ENDPOINT_LIST.length === 1 &&
      (!endpoint.isChecked || endpoint.isChecked === null)
    ) {
      return;
    }

    if (systemtype === false) {
      setSearchEndpointList(
        searchEndpointList.map((e) =>
          e.ENDPOINT_ID === endpoint.ENDPOINT_ID
            ? { ...e, isChecked: !e.isChecked }
            : { ...e, isChecked: false }
        )
      );
    } else {
      setSearchEndpointList(
        searchEndpointList.map((e) =>
          e.ENDPOINT_ID === endpoint.ENDPOINT_ID
            ? { ...e, isChecked: !e.isChecked }
            : e
        )
      );
    }

    const updatedEndpoint = { ...endpoint, isChecked: !endpoint.isChecked };
    setSchedule((pre) => {
      const filteredList = pre.ENDPOINT_LIST.filter(
        (item) => updatedEndpoint.ENDPOINT_ID !== item.ENDPOINT_ID
      );

      if (updatedEndpoint.isChecked) {
        filteredList.push(updatedEndpoint);
      }
      return { ...pre, ENDPOINT_LIST: filteredList };
    });
  };

  const handleDeptSelect = (dept) => {
    getEndpoints(dept.value);

    // 하위 부서가 있는 경우
    if (dept.children && dept.children.length > 0) {
      // 경로에 현재 부서 추가
      setCurrentDeptPath((prev) => [...prev, dept]);
      setSelectedDept(null);
    } else {
      // 하위 부서가 없을때 드롭다운 닫기
      setSelectedDept(dept);
      setDropdownOpen(false);
    }
  };

  const handleBack = () => {
    // 현재 경로
    const currentPath = [...currentDeptPath];
    // 이전 경로
    const newPath = currentPath.slice(0, -1);

    if (newPath.length > 0) {
      const previousDept = newPath[newPath.length - 1];
      getEndpoints(previousDept.value);
    } else {
      // 최상위로 돌아간 경우 최상위 부서 목록의 첫 번째 항목으로 조회
      if (endpointDeptList && endpointDeptList.length > 0) {
        getEndpoints(endpointDeptList[0].value);
      }
    }

    setCurrentDeptPath((prev) => prev.slice(0, -1));
  };

  const getCurrentDeptItems = () => {
    if (currentDeptPath.length === 0) {
      return endpointDeptList;
    }
    const currentDept = currentDeptPath[currentDeptPath.length - 1];
    return currentDept.children || [];
  };

  const getDropdownItems = () => {
    const items = [];

    // 뒤로가기 버튼 (첫 화면이 아닌 경우에반)
    if (currentDeptPath.length > 0) {
      items.push({
        key: "back",
        label: (
          <div
            className={styles.backButton}
            onClick={(e) => {
              e.stopPropagation();
              handleBack();
            }}
          >
            <LeftOutlined />
            <span>이전</span>
          </div>
        ),
      });
    }

    const currentItems = getCurrentDeptItems();
    currentItems.forEach((dept) => {
      items.push({
        key: dept.value,
        label: (
          <div
            className={styles.deptItem}
            onClick={(e) => {
              e.stopPropagation();
              handleDeptSelect(dept);
            }}
          >
            <span>{dept.label}</span>
            {dept.children && dept.children.length > 0 && <RightOutlined />}
          </div>
        ),
      });
    });

    return { items };
  };

  const getDisplayText = () => {
    // 드롭다운이 열려있을 때: 현재 탐색 중인 경로만 표시
    if (dropdownOpen) {
      return currentDeptPath.length > 0
        ? currentDeptPath.map((dept) => dept.label).join(" / ")
        : t("PLACEHOLDER.INPUT.SELECT_PLACE");
    }
    // 드롭다운이 닫혀있을 때: 최종 선택된 전체 경로 표시
    else {
      if (selectedDept) {
        return [
          ...currentDeptPath.map((dept) => dept.label),
          selectedDept.label,
        ].join(" / ");
      }
      return currentDeptPath.length > 0
        ? currentDeptPath.map((dept) => dept.label).join(" / ")
        : t("PLACEHOLDER.INPUT.SELECT_PLACE");
    }
  };

  const handleCloseEndpointSideBox = () => {
    resetDeptSelection();
    closeEndpointSideBox();
  };

  const resetDeptSelection = () => {
    setCurrentDeptPath([]);
    setSelectedDept(null);
    setSearchEndpointList([]);
  };

  return (
    <>
      <EndpointDetail
        isOpen={isDetailOpen}
        onClose={() => setIsDetailOpen(false)}
        room={room}
      />
      <Drawer
        className={styles.sidebox_drawer}
        open={isOpenEndpointSideBox}
        onClose={closeEndpointSideBox}
        placement="right"
        maskClosable={true}
        height="auto"
        title={null}
        styles={{
          header: { display: "none" },
        }}
      >
        <div className={styles.sideBoxContainer}>
          <div className={styles.sideboxHeader}>
            <img
              src={
                process.env.REACT_APP_CLIENT_URL +
                "img/mobile/mypage/close_left.png"
              }
              alt="close"
              onClick={handleCloseEndpointSideBox}
            />
            <span className={styles.sideboxTitle}>
              {t("LABEL.TITLE.MEETING_ROOM")}
            </span>
            <span
              className={styles.sideboxConfirmBtn}
              onClick={handleCloseEndpointSideBox}
            >
              {t("BTN.COMPLETE")}
            </span>
          </div>

          <div className={styles.res_popup_sideBox_container_content}>
            <div className={styles.res_popup_input_label}>
              {t("LABEL.MEETING_PLACE")}
            </div>

            <Dropdown
              menu={getDropdownItems()}
              open={dropdownOpen}
              onOpenChange={(open) => {
                //if (!(selectedDept && !currentDeptPath.length)) {
                setDropdownOpen(open);
                // }
              }}
              trigger={["click"]}
              overlayClassName={styles.locationDropdown}
            >
              <div className={styles.dropdownTrigger}>
                <span>{getDisplayText()}</span>
                <RightOutlined className={dropdownOpen ? styles.rotated : ""} />
              </div>
            </Dropdown>

            <div className={styles.tabsItemContent}>
              {searchEndpointList.map((endpoint) => (
                <ul
                  className={styles.tabsItem_endpoints}
                  key={endpoint.ENDPOINT_ID}
                >
                  <li className={styles.tabsItem_endpointChkbox}>
                    <Checkbox
                      className={styles.boxDetail}
                      checked={endpoint.isChecked}
                      onChange={() => handleSearchEndpointCheck(endpoint)}
                    />
                  </li>
                  <li className={styles.tabsItem_endpointNm}>
                    {endpoint.ENDPOINT_NM}
                  </li>
                  <li
                    className={styles.tabsItem_roomIcon}
                    onClick={() => {
                      // endpoint 데이터를 room 형식에 맞게 변환
                      const roomData = {
                        id: endpoint.ENDPOINT_ID,
                        title: endpoint.ENDPOINT_NM,
                        capacity: endpoint.CAPACITY || 0,
                        dept_code: endpoint.DEPT_CD || "",
                        endpoint: {
                          name: endpoint.ENDPOINT_NM,
                        },
                        fixture: endpoint.FIXTURE || [],
                        img: endpoint.FILE_URL || "",
                        location: endpoint.DEPT_NM_PARENT
                          ? endpoint.DEPT_NM_PARENT.split(",")
                          : [],
                        time: {
                          open: endpoint.OPENTIME || "",
                          close: endpoint.CLOSETIME || "",
                        },
                      };

                      setIsDetailOpen(true);
                      setRoom(roomData);
                    }}
                  >
                    <img
                      src={
                        process.env.REACT_APP_CLIENT_URL + "img/menu/search.png"
                      }
                      alt="video-camera"
                    />
                  </li>
                  <li className={styles.tabsItem_endpointIcon}>
                    {endpoint.ENDPOINT_TYPE !== "CD1001" && (
                      <img
                        src={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/menu/video-camera.png"
                        }
                        alt="video-camera"
                      />
                    )}
                  </li>
                </ul>
              ))}
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
}
